import React from 'react';
import NewsItem from './NewsItem.jsx';
import style from './style.scss';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

class News extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <Tabs className='news-tab'>
        <TabList className='news-tab-list'>
          <div className='news-tab-wrap'>
            <Tab className='news-tab-item'>
              <div className='news-tab-wrap-item'>Đang diễn ra</div>
            </Tab>
            <Tab className='news-tab-item'>
              <div className='news-tab-wrap-item'>Sắp diễn ra</div>
            </Tab>
          </div>
        </TabList>
        <div className='news-tab-content'>
          <TabPanel className='news-tab-panel'><NewsItem/></TabPanel>
          <TabPanel className='news-tab-panel'><NewsItem/></TabPanel>
        </div>
      </Tabs>
    );
  }
}

export default News;


// WEBPACK FOOTER //
// ./components/users/sub-view/the-news/news/News.jsx